import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      categoryBanner: {
        livejasmin: {
          ...defineMessages({
            publicPlaces: {
              id: 'pages.landing.categoryBanner.livejasmin.publicPlaces',
              defaultMessage: 'Public Places',
            },
            flirting: {
              id: 'pages.landing.categoryBanner.livejasmin.flirting',
              defaultMessage: 'Flirting',
            },
            fetish: {
              id: 'pages.landing.categoryBanner.livejasmin.fetish',
              defaultMessage: 'Fetish',
            },
            asmr: {
              id: 'pages.landing.categoryBanner.livejasmin.asmr',
              defaultMessage: 'ASMR',
            },
            noFace: {
              id: 'pages.landing.categoryBanner.livejasmin.noFace',
              defaultMessage: 'No Face',
            },
            cosplay: {
              id: 'pages.landing.categoryBanner.livejasmin.cosplay',
              defaultMessage: 'Cosplay',
            },
          }),
        },
      },
    },
  },
};
